// Detects mobile / touch-only browsers where popup-and-redirect-later flows
// (window.open, signInWithPopup) are unreliable — mobile Safari/Chrome block
// the popup outright or drop the opener reference once the user leaves the
// tab (e.g. an account chooser or Stripe Checkout taking it over), so the
// flow silently stalls instead of erroring. Callers should route these
// browsers through full-page navigation instead of the popup/new-tab dance.
export function isMobileOrTouchBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (/Android|iPhone|iPad|iPod|Mobile|Silk|BlackBerry|Opera Mini|IEMobile/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ masquerades as desktop Safari ("Macintosh") but is touch-only —
  // popups fail there the same way, so treat it as mobile too.
  return (
    /Macintosh/.test(ua) &&
    typeof document !== "undefined" &&
    navigator.maxTouchPoints > 1
  );
}
